import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  input: {
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      '& .MuiAutocomplete-endAdornment': {
        right: theme.spacing(7),
      },
    },
  },
  clearIndicator: {
    '& span': {
      '& svg': {
        '& path': {
          d:
            "path('M5.58 4.21l.094.083 6.293 6.292 6.293-6.29c.39-.391 1.023-.391 1.414 0 .36.36.388.927.083 1.32l-.083.093L13.38 12l6.293 6.293c.39.39.39 1.024 0 1.414-.36.36-.928.388-1.32.083l-.094-.083-6.294-6.293-6.292 6.293c-.39.39-1.024.39-1.414 0-.36-.36-.389-.928-.084-1.32l.084-.094L10.552 12 4.26 5.707c-.39-.39-.39-1.024 0-1.414.33-.33.835-.381 1.219-.153l.101.07z')",
        },
      },
    },
  },
  submit: {
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(1),
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  hasValue: {
    '& .MuiInputBase-root': {
      color: theme.palette.primary.light,
      borderColor: fade(theme.palette.primary.main, 0.16),
      backgroundColor: theme.palette.primary.lighter,
    },
  },
  link: {
    width: '100%',
    fontWeight: '600',
    padding: theme.spacing(0.9),
    '&:hover': {
      textDecoration: 'none',
    },
  },
  noLink: {
    color: theme.palette.grey[300],
    width: '100%',
    fontWeight: '500',
    padding: theme.spacing(0.9),
  },
}))

export default useStyles
